import { api, apiRequest } from "./api";

export interface MonitoringFrequency {
  id: number;
  name: string;
  display_text: string;
}

export const frequencyAPI = {
  list: () => apiRequest<MonitoringFrequency[]>(() => api.get("/frequency/")),
};
